module.exports = __webpack_public_path__ + "static/img/fullscreen-image_or-add-your-own.621ef83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_or-add-your-own.png
// module id = nHBS
// module chunks = 0